module.exports = __webpack_public_path__ + "static/img/Bachelor_010555.87f4b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010555.jpg
// module id = 188
// module chunks = 0